// Repeated utm params serialized with array brackets (e.g. ?utm_source%5B0%5D=a&utm_source%5B1%5D=b)
// reach analytics.js as separate campaign keys, which the warehouse turns into extra columns.
const BRACKETED_KEY = /^(.+?)(?:\[\d*\]|%5B\d*%5D)$/i;

export default function normalizeCampaignParams(campaign) {
  if (!campaign) {
    return campaign;
  }

  const result = {};
  const bracketed = {};

  Object.entries(campaign).forEach(([key, value]) => {
    const match = key.match(BRACKETED_KEY);
    if (match) {
      bracketed[match[1]] = value;
    } else {
      result[key] = value;
    }
  });

  Object.entries(bracketed).forEach(([key, value]) => {
    if (result[key] === undefined) {
      result[key] = value;
    }
  });

  return result;
}
